/* Cool-jams size guide panel wiring (Body / Garment / How to measure tabs + in/cm).
   Lived inline in snippets/size-chart-panel.liquid until 2026-09-02; moved here and
   loaded globally from theme.liquid because the panel's markup reaches non-PDP pages
   only through innerHTML injection (the theme ToolTip AND the quick-shop modal), and
   injected script tags never execute. One global copy wires every .cj-sc it can see:
   on load, on tooltip:open, and on quickview:loaded. */
(function () {
  if (window.__cjSizeChartReady) return;
  window.__cjSizeChartReady = true;

  // Inches print exactly as specified. The factory works in quarters and eighths,
  // so rounding to one decimal would turn 24.25 into 24.3 and 8.375 into 8.4.
  // Only the centimetre conversion is rounded, to one decimal.
  function fmtIn(raw) {
    var n = parseFloat(raw);
    return isNaN(n) ? raw : String(n);
  }

  function fmtCm(inches) {
    return (inches * 2.54).toFixed(1).replace(/\.0$/, '');
  }

  function setUnit(root, unit) {
    root.querySelectorAll('[data-sc-unit]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-sc-unit') === unit);
    });
    root.querySelectorAll('td[data-in]').forEach(function (td) {
      var raw = td.getAttribute('data-in');
      var hi = td.getAttribute('data-in-hi');
      var lo = parseFloat(raw);
      if (isNaN(lo)) return;
      if (hi === null) {
        td.textContent = unit === 'cm' ? fmtCm(lo) : fmtIn(raw);
      } else {
        var h = parseFloat(hi);
        td.textContent = unit === 'cm'
          ? fmtCm(lo) + '–' + fmtCm(h)
          : fmtIn(raw) + '–' + fmtIn(hi);
      }
    });
    root.querySelectorAll('[data-sc-unitword]').forEach(function (el) {
      el.textContent = unit === 'cm' ? 'centimetres' : 'inches';
    });
  }

  function showTab(root, want) {
    root.querySelectorAll('[data-sc-tab]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-sc-tab') === want);
    });
    root.querySelectorAll('[data-sc-pane]').forEach(function (p) {
      p.hidden = p.getAttribute('data-sc-pane') !== want;
    });
  }

  // The "already wired" flag MUST NOT be a data attribute. The tooltip clones this
  // markup with innerHTML, so a data-sc-wired attribute is copied into the clone and
  // the modal's panel is then skipped, leaving it with no listeners at all. That is
  // exactly the bug Sandra hit on 2026-08-29. A WeakSet cannot be serialised.
  var wired = new WeakSet();

  function wire(root) {
    if (wired.has(root)) return;
    wired.add(root);
    root.removeAttribute('data-sc-wired');
    root.querySelectorAll('[data-sc-tab]').forEach(function (b) {
      b.addEventListener('click', function () { showTab(root, b.getAttribute('data-sc-tab')); });
    });
    root.querySelectorAll('[data-sc-unit]').forEach(function (b) {
      b.addEventListener('click', function () { setUnit(root, b.getAttribute('data-sc-unit')); });
    });
    var active = root.querySelector('[data-sc-unit].is-active');
    setUnit(root, active ? active.getAttribute('data-sc-unit') : 'in');
  }

  function wireAll() {
    document.querySelectorAll('.cj-sc').forEach(wire);
  }
  wireAll();
  document.addEventListener('DOMContentLoaded', wireAll);
  document.addEventListener('tooltip:open', function () { setTimeout(wireAll, 0); });
  // Quick-shop modals inject the panel markup with its script tag inert (innerHTML
  // never executes scripts), so rewire when the theme announces a loaded quick view.
  document.addEventListener('quickview:loaded', function () { setTimeout(wireAll, 0); });
})();
